<template>
	<div class="loadingProcess" :class="{ 'ac-bg-black': ac }">
		<header-component
			:is-soon="false"
			img-left=""
			img-right="/trocachip/img/access.png"
			class="header-component"
			:backRoute="false"
		/>
		<div class="change_chip_container">
			<img src="img/validation-carousel/check-success.png" />
			<div class="loadingProcess_description">
				<span v-html="loadingProcess.description"></span>
			</div>
		</div>
	</div>
</template>

<script>
import HeaderComponent from '../components/HeaderComponent';
import { mapState } from 'vuex';

export default {
	name: 'loadingProcess',
	components: {
		HeaderComponent,
	},
	created() {
		setTimeout(
			() => this.$router.push({ name: 'install_esim' }),
			this.loadingProcess.timeout
		);
	},
	data() {
		return {
			description: '',
		};
	},
	computed: mapState({
		ac: (state) => state.ac,
		loadingProcess: (state) => state.config.loadingProcess || {},
	}),
};
</script>

<style lang="scss">
.loadingProcess {
	width: 100%;
	height: 100%;
	display: block;
	position: absolute;
	.change_chip_container {
		width: 90%;
		height: auto;
		margin: 0 5%;
		display: flex;
		flex-direction: column;
		align-items: center;
		box-sizing: content-box;
		> img {
			margin-top: 300px;
			max-height: 35px;
		}
	}
	.loadingProcess_description {
		width: 309px;
		min-height: 48px;
		margin: 16px auto 23px auto;
		display: block;
		position: relative;
		font-family: 'timsans_regular';
		font-weight: 400;
		line-height: 21px;
		text-align: center;
		> span {
			width: 309px;
			height: 48px;
			font-size: 18px;
			font-stretch: normal;
			font-style: normal;
			letter-spacing: normal;
			color: #696969;
		}
	}
}
</style>
